;(function () {
  angular.module('contrast.filters').filter('locNumber', function () {
    return function (loc, precision) {
      if (isNaN(parseFloat(loc)) || !isFinite(loc)) {
        return '-'
      }
      if (typeof precision === 'undefined') {
        precision = 1
      }
      if (loc == 0) {
        return 0
      }
      var number = Math.floor(Math.log(loc) / Math.log(1000))
      if (
        (loc / Math.pow(1000, Math.floor(number))).toFixed(precision).toString()
          .length > 3
      ) {
        return Math.ceil(loc / Math.pow(1000, Math.floor(number))).toFixed(0)
      }
      return (loc / Math.pow(1000, Math.floor(number))).toFixed(precision)
    }
  })
})()
